import { Barcode } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Chip, ChipOption } from "../../components/ui/chip/chip";
import { useMTUs } from "../../queries/mtu/use-mtus";
import { useTasks } from "../../queries/tasks/use-tasks";

export function MTUSelector() {
  const { t } = useTranslation();
  const { MTUs, isPending, selected, setSelected, error, refetch } = useMTUs();
  const { allTasks } = useTasks();

  const options: ChipOption[] =
    MTUs?.map((x) => ({
      label: x.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code ?? "",
      value: x.Id,
      completed:
        allTasks?.filter(
          (task) =>
            task.Description ===
              x?.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code &&
            task.Status?.StatusNId !== "Completed"
        ).length === 0,
    })) ?? [];

  return (
    <>
      <Chip
        title={t("header.serialNumber")}
        value={selected?.Id ?? ""}
        loading={isPending}
        icon={<Barcode />}
        expandable={options.length > 1}
        options={options}
        onSelect={setSelected}
        error={error}
        onRetry={refetch}
      />
    </>
  );
}
